import { CheckIfNotEmpty } from '../helper/StringUtils';

const AuthService = {
  isAuthenticated: true,
  isLoggedIn() {
    return this.isAuthenticated && CheckIfNotEmpty(sessionStorage.authToken);
  },
  authenticate(token) {
    if (CheckIfNotEmpty(token)) {
      this.isAuthenticated = true;
      sessionStorage.authToken = token;
    }
  },
  signOut() {
    this.isAuthenticated = false;
    sessionStorage.clear();
  },

  checkForClientApp() {
    const appType = process.env.REACT_APP_AUDIENCE_TYPE;
    return appType && (appType.toUpperCase()).trim() === ('CLIENTAPP').trim();
  },

};

export default AuthService;
